/**
 * Created by PuTi(编程即菩提) 9/1/17.
 */

var nb = require('../../../nb');
var $ = nb.opts.$;
var alerts = require('../../../model/Alerts');
var config = require('../../../config/' + process.env.APP_CONFIG + '.json');
var io = require('../../../io/' + process.env.APP_ENV + '/io');
var swiperItem2 = require('../../../view/Swiper').swiperItem2;
var util = require('../../../util');
var xModel = require('../../../model/XModel');
var movieImgList = require('./MovieImgList');
var wxLogin = require('../../../io/' + process.env.APP_ENV + '/wxLogin');
var movieBanner = require('../view/MovieBanner').movieBanner;
var trace = require('../../../../nb/trace/js/trace');
var getWxArticleBanner = require('../../../io/' + process.env.APP_ENV + '/storyList/getWxArticleBanner');

var swiperItemModel = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            this.onChange('imgUrl', function (inEvent, inUrl) {
                return 'url(' + inUrl + ')'
            }, this, {before: true});    //监听拿到数据之前
        }
    }
});
var SwiperList = nb.define({
    parent: nb.model.List,
    method: {
        getItemType: function (index, inItem) {
            if (index === 0) {
                return movieBanner
            } else {
                return swiperItem2
            }
        },
        getItemModelType: function (index, inItem) {
            if (index === 0) {
                return movieImgList
            } else {
                return swiperItemModel
            }
        }
    }
});

module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        bannerSwiper: nb.Model,
        story: require('./Story'),
        list: require('./SeriesList')
    },
    method: {
        init: function () {
            var self = this;
            nb.model.onChange(nb.opts.clientReady, function (inEvent) {
                this.getWxArticleBanner();
                var param = util.getParam();
                var code = param['code'];
                var state = param['state'];
                this.set('code', code);
                if (!code && state !== "wechat") {
                    return
                }
                this.wxLogin();
            }, this);

            this.onChange('initData', function (inEvent, inData) {
                this.set('list', {
                    items: inData.seriesList || []
                });
                this.parseBannerSwiper(inData.carouselList);
                nb.model.set('refreshLazyLoad', new Date());
            }, this)
        },
        getWxArticleBanner: function () {
            getWxArticleBanner({
                scope: this,
                success: function (inResp) {
                    var items = inResp.list || [];
                    $.each(items, function (inIndex, inItem) {
                        inItem.imgUrl = inItem.bannerImgUrl + '?x-image-process=image/resize,m_fill,h_352,w_600,limit_0';
                        inItem.linkUrl = inItem.articleUrl;
                    });
                    this.set('story', {
                        storyList: {
                            items: items
                        }
                    });
                    this.set('storyReady', new Date());
                }
            })
        },
        wxLogin: function () {
            var code = this.get('code');
            wxLogin({
                data: {
                    code: code
                },
                scope: this,
                success: function (inResp) {
                    if (inResp.phone) {
                        var token = inResp.token;
                        $.cookie('ARTW_nickname', inResp.nickName);
                        if (token) {
                            $.cookie('ARTW_token', inResp.token);
                            io.setToken(token);
                            trace.setUserId(inResp.userId);
                            _hmt.push(['_trackEvent', '用户', '登录', 'userId', inResp.userId]);
                            trace.log({
                                act: '用户登录'
                            });
                        }
                        setTimeout(function () {
                            xModel.set('loginReady', true, {skipSameValue: false});
                        }, 200);
                    } else {
                        this._setCookieInfo(inResp, 1);
                    }
                },
                error: function (inResp) {
                    alerts.setOpts({
                        text: inResp.error.info,
                        status: 'alert-danger'
                    });
                }
            });
        },
        _setCookieInfo: function (inResp, inType) {
            $.cookie('ARTW_nickname', inResp.nickName);
            $.cookie('ARTW_userId', inResp.userId);
            $.cookie('ARTW_loginType', inType);
            setTimeout(function () {
                window.location.href = 'bindUser.html'
            }, 1000);
        },
        wxLogin: function () {
            var code = this.get('code');
            wxLogin({
                data: {
                    code: code
                },
                scope: this,
                success: function (inResp) {
                    if (inResp.phone) {
                        var token = inResp.token;
                        $.cookie('ARTW_nickname', inResp.nickName);
                        if (token) {
                            $.cookie('ARTW_token', inResp.token);
                            io.setToken(token);
                            trace.setUserId(inResp.userId);
                            _hmt.push(['_trackEvent', '用户', '登录', 'userId', inResp.userId]);
                            trace.log({
                                act: '用户登录'
                            });
                        }
                        setTimeout(function () {
                            // window.location.href='index.html';
                            xModel.set('loginReady', true, {skipSameValue: false});
                        }, 200);
                    } else {
                        this._setCookieInfo(inResp, 1);
                    }
                },
                error: function (inResp) {
                    alerts.setOpts({
                        text: inResp.error.info,
                        status: 'alert-danger'
                    });
                }
            });
        },
        _setCookieInfo: function (inResp, inType) {
            $.cookie('ARTW_nickname', inResp.nickName);
            $.cookie('ARTW_userId', inResp.userId);
            $.cookie('ARTW_loginType', inType);
            setTimeout(function () {
                window.location.href = 'bindUser.html'
            }, 1000);
        },
        parseBannerSwiper: function (inList) {
            var swiperList = new SwiperList;
            var list = [];
            $.each(inList, function (index, item) {
                list.push({
                    imgUrl: item.imgUrl + '?x-image-process=image/resize,m_fill,h_720,w_1920,limit_0',
                    swiperItemHref: item.url + '?key=' + item.key
                });
            });
            list.unshift({
                imgUrl: 'url("https://art-west-new-product.obs.cn-north-4.myhuaweicloud.com/0729/movie/0.jpg")'
            });
            swiperList.setOpts({
                items: list
            });
            var swiper = {
                swiperId: 'swiper-banner',
                swiperList: swiperList
            };
            if (inList.length > 0) {
                this.set('bannerReady', new Date());
            }
            this.set('bannerSwiper', swiper);

            this.set('bannerStatus', 'enter');
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/Content.js
// module id = 402
// module chunks = 1